import React, { useState } from "react";
import Button from "../Button";
import { tutorialsData as tutors } from "../tutorial/faketutorialdata";
// import rating from "../../assets/svgs/rating.svg"
import Rating from "@mui/material/Rating";
import { styled } from "@mui/material/styles";
import sadFace from "../../assets/svgs/smiling-tear.svg"
import Overlay from "../modal/overlay/Overlay";
import completed from "../../assets/images/completed.png"

const TutorSelect = ({handleTimeSelected}: {
    handleTimeSelected : () => void
  }) => {
  const availableTutors = tutors.slice(0, 2);
  return (
    <>
    <div className="bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] h-[60vh] mt-5 p-5  rounded-xl">
      <p className="text-main-blue text-lg">Available Tutors</p>
      <div>
        {availableTutors.length === 0 && 
        <>
        <div className = "w-[100%] flex flex-col justify-center items-center mt-8">
            <img src = {sadFace} alt = "" />
            <p className = "mt-10 text-xl ">No tutors available. Select another time.</p>
            <Button onClick={handleTimeSelected}>Go back</Button>
        </div>
        </>
        }
        {availableTutors.map((tutor) => (
          <Tutor
            name={tutor.tutor}
            rating={tutor.rating}
            field={tutor.field}
            experience={tutor.experience}
            time = "3:00PM"
          />
        ))}
      </div>
    </div>
    </>
  );
};

export default TutorSelect;

const Tutor = ({
  name,
  rating,
  field,
  experience,
  time
}: {
  name: string;
  rating?: number;
  field?: string;
  experience?: string;
  time: string
}) => {
    const [success, setSuccess] = useState(false)
    const [booked, setBooked] = useState(false)
    const handleCloseSuccess = () => {
        setSuccess(!success)
        setBooked(true)
    }
  return (
    <>
    <Overlay isOpen = {success} onClose = {handleCloseSuccess}>
        <div className = "w-[100%] flex flex-col justify-center items-center text-main-blue text-xl mt-12">
            <div className = "mb-5">
                <img src = {completed} alt= "" />
            </div>
            <p>Welldone Champ. You have </p>
            <p>succesfully completed the</p>
            <p>interview booking task</p>
            <div className = "mt-10">

            </div>
        </div>
    </Overlay>
    <div className = "grid grid-cols-[35%_18%_17%_15%_15%] items-center my-3 text-base py-2 border-b-[0.5px] border-b-[rgba(0,_0,_0,_0.2)]">
      <div className = "flex">
        <p>{name}</p>
        <div className = "ml-2 flex items-center">
          <StyledRating name="read-only" value={rating} size="small" readOnly />
        </div>
      </div>
      <p>{field}</p>
      <p>{experience}</p>
      <div>{time}</div>
        <Button onClick = {() => {setSuccess(!success)}}>
            {booked ? "Booked!": "Book Tutor"}
        </Button> 
    </div>
    </>
  );
};

// const Star = ()=> {
//     return(
//         <img src = {rating} alt = "" />
//     )
// }
const StyledRating = styled(Rating)({
    '& .MuiRating-iconFilled': {
      color: '#017E91',
    }
  });